
export function createHeaders(columnsConfig, actionsConfig, sourceMapper) {
  let headers = [];
  if (columnsConfig) {
    columnsConfig.forEach(col => {
      let value = col.field;
      value = Array.isArray(value) ? value.join('__') : value;
      value = value.replace('.', '');
      headers.push({
        text: col.label,
        value,
        sortable: col.sortable,
        align: col.align,
        width: col.width,
        type: col.type,
      });
      const key = JSON.stringify(Array.isArray(col.field) ? col.field: [col.field]);
      if (sourceMapper) {
        sourceMapper[key] = value;
      }
    });

    (actionsConfig || []).forEach(action => {
      headers.push({
        text: action.label,
        value: action.id,
        sortable: false,
        align: 'center',
        width: '40px',
        default: true,
        simpleAction: true,
        icon: action.icon,
        color: action.color,
      });
    })
  }
  return headers;
}

export function mapItems(items, sourceMapper) {
  const resItems = (items || []).map(t => {
    let res = Object
      .keys(sourceMapper)
      .reduce((p, map) => {
        const field = sourceMapper[map];
        JSON.parse(map).reverse().forEach(c => {
          let currentVal = t;
          c.split('.').forEach((prop)=> {
            if (currentVal !== null && currentVal !== undefined) {
              currentVal = currentVal[prop];
            }
          });
          if (currentVal) {
            p[field] = currentVal;
          }
        });
        return p;
      }, {});
    return { ...t, ...res, };
  });

  return resItems;
}

